import React from 'react';
import { Element } from '@zmedia/bm-soccer-ui/components';
import styles from './style.module.scss';

interface IProps {
    renderAs?: string;
    children?: any;
}

export function TitleHeader({ renderAs = 'div', children }: IProps) {
    return (
        <Element renderAs={renderAs} className={styles['header-title']}>
            {children}
        </Element>
    );
}

export default React.memo(TitleHeader);
